import { useEffect, useState } from 'react'

/**
 * Hash routing, deliberately. It needs no server rewrites, so the app deploys to any
 * static host — including Cloudflare Pages — without a redirect rule, and deep links keep
 * working offline from the cached shell.
 */

export function useRoute(): string {
  const [route, setRoute] = useState(() => window.location.hash.slice(1) || '/')

  useEffect(() => {
    const onChange = () => setRoute(window.location.hash.slice(1) || '/')
    window.addEventListener('hashchange', onChange)
    return () => window.removeEventListener('hashchange', onChange)
  }, [])

  return route
}

export function navigate(path: string): void {
  window.location.hash = path
}

export function back(): void {
  window.history.back()
}
